import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(private http: HttpClient) { }

  sendToken(token) {
    return this.http.post<any>(`${environment.apiUrl}/captcha-validate`, { recaptcha: token });
  }
}
